export const COLLECTION_PLACEHOLDER = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="59"
    viewBox="0 0 76 59"
    fill="none">
    <path
      d="M64.0319 9.4629C66.0584 9.07901 68.0305 10.4229 68.4144 12.4494L75.3943 49.2941C75.7782 51.3205 74.4343 53.2926 72.4078 53.6765L20.8253 63.4484C18.7988 63.8323 16.8267 62.4884 16.4428 60.4619L9.4629 23.6172C9.07901 21.5907 10.4229 19.6186 12.4494 19.2347L64.0319 9.4629ZM62.636 2.09397L11.0534 11.8658C4.93719 13.0245 0.935305 18.897 2.09397 25.0132L9.07386 61.8579C10.2325 67.9741 16.105 71.976 22.2212 70.8173L73.8038 61.0455C79.92 59.8868 83.9219 54.0143 82.7632 47.8981L75.7833 11.0534C74.6247 4.93719 68.7522 0.935305 62.636 2.09397Z"
    />
    <path
      d="M14.9268 59.1079L24.2868 47.0678C25.7921 45.1415 28.4011 44.6091 30.5295 45.7707L38.7065 50.252L51.0759 33.7488C52.6936 31.6103 55.6551 31.1256 57.8603 32.6926L78.4171 47.1184L79.6107 53.4188L16.1273 65.4452L14.9337 59.1448L14.9268 59.1079Z"
    />
    <path
      d="M31.7165 37.5308C35.2775 36.8562 37.6174 33.4225 36.9428 29.8615C36.2682 26.3004 32.8345 23.9605 29.2735 24.6351C25.7125 25.3097 23.3726 28.7434 24.0472 32.3044C24.7218 35.8655 28.1554 38.2054 31.7165 37.5308Z"
    />
  </svg>`;
